<template>
    <div class="md:ppv2-w-[80%] ppv2-w-full">
        <!-- Info Banner -->
        <!-- TODO: Uncomment when InfoBanner.vue is available -->
        <!-- <InfoBanner :text="$t('website_settings.menu.info_banner')" class="ppv2-mb-6" /> -->

        <form @submit.prevent="save">
            <div class="ppv2-flex ppv2-flex-col ppv2-gap-6">
                <!-- À propos Section -->
                <SectionCard :title="$t('website_settings.menu.sections.about')" v-model="form.enabled_menu_propos">
                    <div class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-2" :style="{ gap: normalizeSize(16, true) }">
                        <div>
                            <CustomInput
                                :label="$t('website_settings.menu.sections.about_label')"
                                customLabelClass="poppinsLight"
                                v-model="form.title_menu_propos"
                                :placeholder="getPlaceholder('about')"
                            />
                        </div>
                    </div>
                </SectionCard>

                <!-- Nos offres Section -->
                <SectionCard :title="$t('website_settings.menu.sections.discover')" :hideToggle="true">
                    <div class="ppv2-flex ppv2-flex-col ppv2-gap-6">
                        <div
                            v-for="(sub, sIdx) in discoverSections"
                            :key="sIdx"
                            class="ppv2-flex ppv2-justify-between ppv2-items-end"
                            :style="{ gap: normalizeSize(16, true) }"
                        >
                            <div class="ppv2-flex-1">
                                <CustomInput
                                    :label="$t(sub.labelKey)"
                                    customLabelClass="poppinsLight"
                                    v-model="form[sub.titleModel]"
                                    :placeholder="getPlaceholder(sub.placeholderKey)"
                                />
                            </div>
                            <div class="ppv2-flex ppv2-justify-end ppv2-items-center ppv2-mb-[20px] ppv2-h-[34px]">
                                <BaseSwitch
                                    customLabelStyle="poppinsLight"
                                    :label="form[sub.enabledModel] ? $t('common.enabled') : $t('common.disabled')"
                                    v-model="form[sub.enabledModel]"
                                />
                            </div>
                        </div>
                    </div>
                </SectionCard>

                <!-- Other Sections -->
                <div v-for="(section, idx) in otherSections" :key="idx">
                    <SectionCard :title="$t(section.titleKey)" v-model="form[section.enabledModel]">
                        <div class="ppv2-grid ppv2-grid-cols-1 md:ppv2-grid-cols-2" :style="{ gap: normalizeSize(16, true) }">
                            <div>
                                <CustomInput
                                    :label="$t(section.labelKey)"
                                    customLabelClass="poppinsLight"
                                    v-model="form[section.titleModel]"
                                    :placeholder="getPlaceholder(section.placeholderKey)"
                                />
                            </div>
                        </div>
                    </SectionCard>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import normalizeSize from '../../../../../utils/normalizeSize'

import CustomInput from '../../../../Inputs/CustomInput.vue'
import BaseSwitch from '../../../../Shared/BaseSwitch.vue'
import BaseButton from '../../../../Shared/BaseButton.vue'
import BaseLabel from '../../../../Shared/BaseLabel.vue'
import SectionCard from './SectionCard.vue'
// TODO: Uncomment when InfoBanner.vue is available
// import InfoBanner from '../../../../Shared/InfoBanner.vue'
import { Menu } from 'lucide-vue'

export default {
    name: 'TabMenu',
    components: {
        CustomInput,
        BaseSwitch,
        BaseButton,
        BaseLabel,
        SectionCard,
        Menu,
        // TODO: Uncomment when InfoBanner.vue is available
        // InfoBanner,
    },
    props: {
        data: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            saving: false,
            form: {
                title_menu_propos: '',
                title_menu_res: '',
                title_menu_offer: '',
                title_menu_gift: '',
                title_menu_event: '',
                title_menu_subscription: '',
                title_menu_restaurant: '',
                title_menu_help_us_section: '',
                title_menu_contact: '',
                title_menu_shop: '',
                title_menu_blog: '',
                enabled_menu_propos: true,
                enabled_menu_res: true,
                enabled_menu_offer: true,
                enabled_menu_gift: true,
                enabled_menu_event: true,
                enabled_menu_subscription: true,
                enabled_menu_restaurant: true,
                enabled_menu_help_us_section: true,
                enabled_menu_contact: true,
                enabled_menu_shop: true,
                enabled_menu_blog: true,
            },
        }
    },
    watch: {
        'form.enabled_menu_gift'(newVal) {
            this.syncGiftSettings(newVal)
        },
        'form.enabled_menu_offer'(newVal) {
            this.syncOfferSettings(newVal)
        },
    },
    computed: {
        discoverSections() {
            return [
                {
                    titleModel: 'title_menu_res',
                    enabledModel: 'enabled_menu_res',
                    labelKey: 'website_settings.menu.sections.res_label',
                    placeholderKey: 'res',
                },
                {
                    titleModel: 'title_menu_offer',
                    enabledModel: 'enabled_menu_offer',
                    labelKey: 'website_settings.menu.sections.offer_label',
                    placeholderKey: 'offer',
                },
                {
                    titleModel: 'title_menu_gift',
                    enabledModel: 'enabled_menu_gift',
                    labelKey: 'website_settings.menu.sections.gift_label',
                    placeholderKey: 'gift',
                },
                {
                    titleModel: 'title_menu_restaurant',
                    enabledModel: 'enabled_menu_restaurant',
                    labelKey: 'website_settings.menu.sections.rest_label',
                    placeholderKey: 'rest',
                },
                {
                    titleModel: 'title_menu_event',
                    enabledModel: 'enabled_menu_event',
                    labelKey: 'website_settings.menu.sections.event_label',
                    placeholderKey: 'event',
                },
                {
                    titleModel: 'title_menu_subscription',
                    enabledModel: 'enabled_menu_subscription',
                    labelKey: 'website_settings.menu.sections.sub_label',
                    placeholderKey: 'sub',
                },
                /*{
                    titleModel: 'title_menu_help_us_section',
                    enabledModel: 'enabled_menu_help_us_section',
                    labelKey: 'website_settings.menu.sections.help_label',
                    placeholderKey: 'help',
                },*/
            ]
        },
        otherSections() {
            return [
                {
                    titleKey: 'website_settings.menu.sections.contact',
                    titleModel: 'title_menu_contact',
                    enabledModel: 'enabled_menu_contact',
                    labelKey: 'website_settings.menu.sections.contact_label',
                    placeholderKey: 'contact',
                },
                /*{
                    titleKey: 'website_settings.menu.sections.shop',
                    titleModel: 'title_menu_shop',
                    enabledModel: 'enabled_menu_shop',
                    labelKey: 'website_settings.menu.sections.shop_label',
                    placeholderKey: 'shop',
                },*/
                {
                    titleKey: 'website_settings.menu.sections.blog',
                    titleModel: 'title_menu_blog',
                    enabledModel: 'enabled_menu_blog',
                    labelKey: 'website_settings.menu.sections.blog_label',
                    placeholderKey: 'blog',
                },
            ]
        },
    },
    mounted() {
        this.initializeForm()
        this.$root.$on('sync-gift-settings', this.handleSyncGiftSettings)
        this.$root.$on('sync-offer-settings', this.handleSyncOfferSettings)
    },
    activated() {
        this.$root.$off('website-settings-trigger-save-menu', this.save)
        this.$root.$on('website-settings-trigger-save-menu', this.save)
    },
    deactivated() {
        this.$root.$off('website-settings-trigger-save-menu', this.save)
    },
    beforeDestroy() {
        this.$root.$off('website-settings-trigger-save-menu', this.save)
        this.$root.$off('sync-gift-settings', this.handleSyncGiftSettings)
        this.$root.$off('sync-offer-settings', this.handleSyncOfferSettings)
    },
    methods: {
        normalizeSize,
        syncGiftSettings(value) {
            this.$root.$emit('sync-gift-settings', value)
        },
        syncOfferSettings(value) {
            this.$root.$emit('sync-offer-settings', value)
        },
        getPlaceholder(key) {
            const prefix = this.$t('website_settings.menu.placeholder_prefix')
            const contentKey = `website_settings.menu.sections.${key}_placeholder`
            const nameKey = `website_settings.menu.sections.${key}`

            // Use specific placeholder if defined, otherwise use prefix + short name
            if (this.$te(contentKey)) {
                return prefix + this.$t(contentKey)
            }
            if (this.$te(nameKey)) {
                return prefix + this.$t(nameKey)
            }
            return this.$t('website_settings.menu.placeholder')
        },
        initializeForm() {
            const settings = this.data?.settings || []
            settings.forEach((s) => {
                if (this.form.hasOwnProperty(s.parameter)) {
                    if (s.parameter.startsWith('enabled_')) {
                        this.form[s.parameter] = s.value === 'on' || s.value === true
                    } else {
                        this.form[s.parameter] = s.value || ''
                    }
                }
            })
        },
        handleSyncGiftSettings(value) {
            if (this.form.enabled_menu_gift !== value) {
                this.form.enabled_menu_gift = value
            }
        },
        handleSyncOfferSettings(value) {
            if (this.form.enabled_menu_offer !== value) {
                this.form.enabled_menu_offer = value
            }
        },
        async save() {
            this.saving = true
            this.$emit('save', { loading: true })
            try {
                const formData = new FormData()
                Object.keys(this.form).forEach((key) => {
                    if (key.startsWith('enabled_')) {
                        formData.append(key, this.form[key] ? 'on' : 'off')
                    } else {
                        formData.append(key, this.form[key])
                    }
                })

                // Ensure both gift and offer fields are sent for synchronization
                formData.append('enabled_bon_cadeau', this.form.enabled_menu_gift ? 'on' : 'off')
                formData.append('enabled_offre_decou', this.form.enabled_menu_offer ? 'on' : 'off')

                const response = await axios.post('/back-office/website/website-settings', formData)
                this.$emit('save', { loading: false, success: true, message: response.data?.message })
            } catch (error) {
                this.$toast.error(error.response.data.message)
                this.$emit('save', { loading: false })
            } finally {
                this.saving = false
            }
        },
    },
}
</script>

<style scoped></style>
